import React from 'react';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';
import { Badge, Card } from 'reactstrap';
import Header from 'app/components/layout/Header';
import CopyCaption from 'app/components/general/CopyCaption';
import Button from 'app/components/general/Button';
import StatusBadge from 'app/components/general/StatusBadge';
import SectionGroup from 'app/components/general/SectionGroup';
import ShareLink from 'app/components/teams/ShareLink';
import { Link } from 'react-router-dom';

import { history } from 'app/routes/history';
import { simpleFriendlyDate, parseAmount } from 'app/utils/parsers';
import { ITeam } from 'app/ducks/teams/types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TeamTeamMembersTable from 'app/components/teamMembers/TeamTeamMembersTable';
import EditTeam from 'app/components/teams/EditTeam';
import Loader from 'app/components/general/Loader';
import IconModal from 'app/components/general/IconModal';

import ModalConfirm from 'app/components/general/ModalConfirm';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import EditAssociationConnection from 'app/features/teams/components/EditAssociationConnection';

import DeleteIcon from 'app/images/icons/delete.svg';
import EditIcon from 'app/images/icons/edit.svg';
import ConnectIcon from 'app/images/icons/connection.svg';
import IconButton from 'app/components/general/IconButton';

import * as teamsActions from 'app/ducks/teams/actions';
import * as teamMembersActions from 'app/ducks/teamMembers/actions';
// import * as matchPaymentActions from 'app/ducks/matchPayments/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as teamMembersSelectors from 'app/ducks/teamMembers/selectors';
// import * as matchPaymentsSelectors from 'app/ducks/matchPayments/selectors';

import CompetitionIcon from 'app/images/icons/leaderboard.svg';
import OrganisationIcon from 'app/images/icons/organisation.svg';

function selector(state) {
  return {
    // matchPayments: matchPaymentsSelectors.getMatchPayments(state),
    teams: teamsSelectors.getTeams(state),
    teamMembers: teamMembersSelectors.getTeamMembers(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamsActions,
  teamMembersActions,
  // matchPaymentActions,
);

interface ITeamDetailProps {
  appReady: boolean;
  actions: any;
  match: any;
  teams: any;
  matchPayments?: any;
  teamMembers?: any;
  backendErrors: any;
  errors: any;
  isLoading: boolean;
}

interface ITeamDetailState {
  connectionLoaded: boolean;
  connectModalOpen: boolean;
  connectModalEdit: boolean;
  editModalOpen: boolean;
  deleteModalOpen: boolean;
  deleteConnectionModalOpen: boolean;
  teamConnection: any;
  connectionsLength: number;
}
@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class TeamDetail extends React.Component<ITeamDetailProps, ITeamDetailState> {
  static defaultProps: ITeamDetailProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    teams: undefined,
    matchPayments: undefined,
    teamMembers: undefined,
    backendErrors: undefined,
    isLoading: false,
    errors: undefined,
  };

  state: ITeamDetailState = {
    editModalOpen: false,
    connectModalOpen: false,
    connectModalEdit: false,
    deleteModalOpen: false,
    deleteConnectionModalOpen: false,
    connectionLoaded: false,
  };

  componentDidMount = (): void => {
    this.props.actions.clearTeamMembers();
    this.props.actions.getTeam(this.props.match.params.teamId);
  };

  static getDerivedStateFromProps(nextProps, prevState): any {
    if ((!prevState.connectionLoaded || prevState.connectionsLength !== nextProps.teams.currentTeam.teamConnections.length)
      && nextProps.teams.currentTeam.id === nextProps.match.params.teamId) {
      const selectedConnection = nextProps.teams.currentTeam.teamConnections[0];
      if (!_.isEmpty(selectedConnection?.group?.id)) {
        return {
          ...prevState,
          teamConnection: {
            id: selectedConnection?.id,
            name: `${selectedConnection?.competitionName} - ${selectedConnection?.teamName}`,
          },
          connectionsLength: nextProps.teams.currentTeam.teamConnections.length,
          connectionLoaded: true,
        };
      }
    }
    return null;
  }

  handleOpenConnectModal = (e, editModal): void => {
    e.preventDefault();
    this.setState({ connectModalOpen: true, connectModalEdit: editModal });
  };

  handleCloseConnectModal = (e, newTeamConnection): void => {
    if (e !== undefined) {
      e.preventDefault();
    }
    const newState = {
      connectModalOpen: false,
      connectModalEdit: false,

    };
    if (newTeamConnection !== undefined) {
      newState.teamConnection = {
        id: newTeamConnection.id,
        name: newTeamConnection.competitionName,
      };
    }
    this.setState(newState);
  };

  handleOpenEditModal = (e): void => {
    e.preventDefault();
    this.setState({ editModalOpen: true });
  };

  handleCloseEditModal = (e): void => {
    e.preventDefault();
    this.setState({ editModalOpen: false });
  };

  handleOpenDeleteModal = (e): void => {
    e.preventDefault();
    this.setState({ deleteModalOpen: true });
  };

  handleCloseDeleteModal = (e): void => {
    e.preventDefault();
    this.setState({ deleteModalOpen: false });
  };

  handleOpenDeleteConnectionModal = (e): void => {
    e.preventDefault();
    this.setState({ deleteConnectionModalOpen: true });
  };

  handleCloseDeleteConnectionModal = (e): void => {
    if (e !== undefined) {
      e.preventDefault();
    }
    this.setState({ deleteConnectionModalOpen: false });
  };

  handleTeamConnectionChange = (e): void => {
    // e.preventDefault();
    this.setState({ teamConnection: e });
  }

  render(): React.ReactNode {
    const team: ITeam = this.props.teams.currentTeam;
    const isLoading = this.props.teams.isLoading && team.id !== this.props.match.params.teamId;
    const actions = [];
    const currentTeamConnection = _.find(this.props.teams.currentTeam?.teamConnections, (t) => t.id === this.state.teamConnection?.id);
    // console.log(currentTeamConnection);
    actions.push(<ShareLink link={`${JOIN_URL}/${team?.inviteToken}`} />);
    actions.push(<Button
      className="btn-standard btn-small btn-2 margin-right-10 margin-bottom-10"
      noLoading
      onClick={this.handleOpenEditModal}
    >
      Edit team
    </Button>);
    actions.push(<Button
      className="btn-standard btn-small btn-2 margin-right-10 margin-bottom-10"
      noLoading
      onClick={this.handleOpenDeleteModal}
    >
      Delete team
    </Button>);

    const statusBadges = (owingNumber, overdueNumber): React.ReactNode[] => {
      const statuses = [];

      if (owingNumber > 0) {
        statuses.push(
          <StatusBadge
            key="owing"
            paymentText="owing"
            numberOfObjects={owingNumber}
          />,
        );
      }
      if (overdueNumber > 0) {
        statuses.push(
          <StatusBadge
            key="overdue"
            paymentText="overdue"
            numberOfObjects={overdueNumber}
          />,
        );
      }
      return statuses;
    };

    const connectionText = `Season Connections (${this.props.teams.currentTeam?.teamConnections?.length})`;

    return (
      <div>
        <div className="row">
          <div className="col">
            <Header
              title={team.name}
              isLoading={isLoading}
              badge={(
                statusBadges(team.pendingTeamPaymentCollectionsTotalCount, team.overdueTeamPaymentCollectionsTotalCount)
              )}
              descriptors={
                [
                  {
                    icon: <Isvg src={OrganisationIcon} />,
                    descriptor: team.organisation?.name,
                  },
                  {
                    icon: <Isvg src={CompetitionIcon} />,
                    descriptor: team.group?.competition?.name,
                  },
                ]
              }
              metadata={[
                {
                  title: 'Season',
                  value: team.seasonName,
                },
                {
                  title: 'Team Members',
                  value: team.numberOfTeamMembers,
                },
                // {
                //   title: 'Forfeits',
                //   value: '5',
                // },
                // {
                //   title: 'Matches',
                //   value: '55',
                // },
                {
                  title: 'Collected',
                  value: parseAmount(team.paidTeamPaymentCollectionsTotalAmount),
                },
                {
                  title: 'Outstanding',
                  value: parseAmount(team.pendingTeamPaymentCollectionsTotalAmount + team.overdueTeamPaymentCollectionsTotalAmount),
                },
                {
                  title: 'Since',
                  value: team.createdAt !== undefined ? simpleFriendlyDate(team.createdAt) : '',
                },

              ]}
            />
          </div>
        </div>
        <IconModal
          title="Connect Team"
          icon={ConnectIcon}
          handleCancel={this.handleCloseConnectModal}
          isOpen={this.state.connectModalOpen}
        >
          <EditAssociationConnection
            {...this.props}
            teamConnectionId={this.state.connectModalEdit ? this.state.teamConnection?.id : null}
            teamId={this.props.match.params.teamId}
            afterSubmit={this.handleCloseConnectModal}
          />
        </IconModal>
        <IconModal
          title="Edit Team"
          icon={EditIcon}
          handleCancel={this.handleCloseEditModal}
          isOpen={this.state.editModalOpen}
        >
          <EditTeam {...this.props} teamId={this.props.match.params.teamId} afterSubmit={this.handleCloseEditModal} />
        </IconModal>
        <ModalConfirm
          title="Delete Team"
          icon={DeleteIcon}
          description="Are you sure you want to delete this team?"
          buttonText="Delete"
          isOpen={this.state.deleteModalOpen}
          isLoading={this.props.isLoading}
          handleSubmit={(e) => this.props.actions.deleteTeam({ id: team.id })}
          handleCancel={this.handleCloseDeleteModal}
        />
        <ModalConfirm
          title="Delete Connection"
          icon={DeleteIcon}
          description="Are you sure you want to delete this association connection?"
          buttonText="Delete"
          isOpen={this.state.deleteConnectionModalOpen}
          isLoading={this.props.isLoading}
          handleSubmit={(e) => this.props.actions.updateTeamConnection({ id: this.state.teamConnection.id, status: 'inactive' }, this.handleCloseDeleteConnectionModal)}
          handleCancel={this.handleCloseDeleteConnectionModal}
        />
        <div className="main-content">
          <div className="row">
            <div className="col col-12 col-lg-8 col-xl-6">
              {actions.length > 0 && (
                <div className="row with-margin-bottom-extra">
                  <div className="col col-12">
                    <SectionGroup title="Actions" isLoading={isLoading}>
                      {/* <div className="btn-flex-group">
                        <div className="btn-flex-container"> */}
                      {_.map(actions, (a) => a)}
                      {/* </div>
                      </div> */}
                    </SectionGroup>
                  </div>
                </div>
              )}
              <SectionGroup
                title="Association Connections"
                // handleEdit={this.handleOpenConnectModal}
                buttons={(this.props.teams?.currentTeam.teamConnections?.length > 0) && (
                  <div className="btn-flex-group w-100">
                    <div className="btn-flex-container float-right no-margin-top">
                      <Button
                        className="btn-standard btn-small btn-2 with-margin-bottom-5"
                        noLoading
                        onClick={this.handleOpenConnectModal}
                      >
                        Connect to another season
                      </Button>
                    </div>
                  </div>
                )}
                isLoading={isLoading || (this.props.teams?.currentTeam.teamConnections?.length > 0 && !this.state.connectionLoaded)}
              >
                {_.isEmpty(currentTeamConnection?.id) && (
                  <span className="with-margin-top-10">
                    <div className="row">
                      <div className="col">
                        Connect your team to your association so you can manage payments
                        &amp; submit forfeits.
                      </div>
                    </div>
                    <div className="row with-margin-top">
                      <div className="col">
                        <Button
                          className="btn-standard btn-small btn-success"
                          noLoading
                          onClick={this.handleOpenConnectModal}
                        >
                          Connect now
                        </Button>
                      </div>
                    </div>
                  </span>
                )}
                { (this.props.teams?.currentTeam.teamConnections?.length > 0) && (
                  <div className="row">
                    <div className="col">
                      <InputGroupBlock
                        type="select"
                        icon={OrganisationIcon}
                        disabled={_.isEmpty(this.state.teamConnection)}
                        labelText={connectionText}
                        name="season"
                        className="height-50"
                        placeholder="Select connection..."
                        aria-label={connectionText}
                        autoComplete="off"
                        inputGroupClassName="no-margin-bottom straight-bottom"
                        // tabIndex="2"
                        // clearable
                        value={this.state.teamConnection}
                        options={teamsSelectors.getTeamConnectionsByIdInSelectFormat(team.teamConnections)}
                        onChange={this.handleTeamConnectionChange}
                      />
                    </div>
                  </div>
                )}

                {!_.isEmpty(currentTeamConnection?.id) && (
                  <Card className="no-shadow-4 with-padding">
                    <div className="row">
                      <div className="col col-4 text-grey">
                        Team Name
                      </div>
                      <div className="col">
                        {currentTeamConnection?.teamName}
                      </div>
                    </div>
                    <div className="row with-margin-top-10">
                      <div className="col col-4 text-grey">
                        Organisation
                      </div>
                      <div className="col">
                        {currentTeamConnection?.organisationName}
                      </div>
                    </div>
                    <div className="row with-margin-top-10">
                      <div className="col col-4 text-grey">
                        Competition/s
                      </div>
                      <div className="col">
                        {currentTeamConnection?.competitionName}
                      </div>
                    </div>
                    <div className="row with-margin-top-10">
                      <div className="col col-4 text-grey">
                        Section/s
                      </div>
                      <div className="col">
                        {currentTeamConnection?.sectionName}
                      </div>
                    </div>
                    <div className="row with-margin-top-10">
                      <div className="col col-4 text-grey">
                        Season/s
                      </div>
                      <div className="col">
                        {currentTeamConnection?.seasonName}
                      </div>
                    </div>
                    <div className="row with-margin-top-10">
                      <div className="col col-4 text-grey">
                        Status
                      </div>
                      <div className="col">
                        <div className="d-flex">
                          <StatusBadge paymentText={(currentTeamConnection?.competitionStatus === 'active' && currentTeamConnection?.groupStatus === 'active') ? 'active' : 'inactive'} />
                        </div>
                      </div>
                    </div>
                    <div className="row with-margin-top-10">
                      <div className="col text-right">
                        <Link to="" className="d-inline-flex justify-content-center align-items-center with-margin-right error" onClick={(e) => this.handleOpenDeleteConnectionModal(e, true)}>
                          <Isvg className="misc-icon" src={DeleteIcon} />
                          <span className="margin-left-10">Disconnect</span>
                        </Link>
                        <Link to="" className="d-inline-flex justify-content-center align-items-center" onClick={(e) => this.handleOpenConnectModal(e, true)}>
                          <Isvg className="misc-icon" src={EditIcon} />
                          <span className="margin-left-10">Edit</span>
                        </Link>
                      </div>
                    </div>
                  </Card>
                )}

              </SectionGroup>
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col">
              <TeamTeamMembersTable
                {...this.props.teamMembers}
                saveFilters={false}
                teamId={this.props.match.params.teamId}
                headerTitle="Team Members"
                appReady={this.props.appReady}
                actions={this.props.actions}
                showChildren
                match={this.props.match}
                isLoading={this.props.teamMembers.isLoading}
                persistentFilterConfig={{
                  teamId: this.props.match.params.teamId,
                }}
                selectTeamMember={this.props.actions.selectTeamMember}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
